module.exports = __webpack_public_path__ + "img/btn-jc-bg.6576cb2f.png";